import React, { useState } from 'react'
import { MenuItem, MenuList } from '@chakra-ui/react'

const Dropdown2 = ({ data, onSelect }) => {
  return (
    <MenuList overflowY='scroll' h='150px'>
      {data?.map((option) => (
        <MenuItem
          closeOnSelect={true}
          textColor='black'
          key={option.value}
          onClick={() => {
            onSelect(option.value)
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </MenuList>
  )
}
export default Dropdown2
